exports = module.exports = require("../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".cardBox{border:calc(.17857vw + 3.42857px) solid #000;padding:calc(2.67857vw + 11.42857px);height:100%;position:relative}.cardBox:hover{border-color:#1a3aff}.cardBox-url{position:absolute;left:0;top:0;right:0;bottom:0}.cardBox-auto{height:auto}", ""]);
